module.exports = __webpack_public_path__ + "img/nochoose.f0c8d2a4.svg";